module.exports = __webpack_public_path__ + "img/amazon_review_request_example.png";